import { find, sortBy, merge, map, isEqual, cloneDeep } from 'lodash'
import dataAccess from './service.data-access'
import { ContentTypes, TabsModes, VacancyModes, NewsModes } from '../models/enums'
import store from '../store/store._index'
import router from '../router/router.index'
export default {
  BuildPage,
  loadPage,
  load,
  buildTabPreview
}

async function loadSubPage(page) {
  store.dispatch('clearSubPage')

  if (page.args && page.args[0]) {
    var content = page.components.filter(e => [ContentTypes.News, ContentTypes.Tabs, ContentTypes.Vacancy].includes(e.contentType))
      .find(t => [NewsModes.Details, TabsModes.Subpage, VacancyModes.Details].includes(t.metadata.mode))
    var subPage

    try {
      switch (content.contentType) {
        case ContentTypes.News:
          if (content.metadata.mode === NewsModes.Details) {
            subPage = await dataAccess.getNews(page.args[0])
          }
          break
        case ContentTypes.Tabs:
          if (content.metadata.mode === TabsModes.Subpage) {
            subPage = await dataAccess.getPage(page.args[0])
          }
          break
        case ContentTypes.Vacancy:
          if (content.metadata.mode === VacancyModes.Details) {
            subPage = await dataAccess.getVacancy(page.args[0])
          }
          break
        default:
          return Promise.resolve()
      }
      await BuildPage(subPage)
      store.commit('setSubPage', subPage)
    } catch (e) {
      console.log(e)
      router.replace({ name: '*' })
      window.location.reload()
    }
  }
}
function buildTabPreview(page) {
  page.hash = new Date().getTime()
  page.metadata = buildMetadata(page.metadata)

  if (page.contents && !page.components) {
    page.components = []

    page.contents.forEach((content, index) => {
      var componentToRender = {
        contentType: getComponentType(content.contentType),
        componentName: getComponentName(content.contentType),
        content: JSON.parse(content.content),
        sortOrder: content.sortOrder,
        metadata: buildMetadata(content.metadata),
        parent: null,
        hash: new Date().getTime() + index
      }
      componentToRender.parent = page

      if (componentToRender != null) {
        page.components.push(componentToRender)
      }
    })
    page.components.sort(e => e.sortOrder)
  }
  return page
}
async function BuildPage(page) {
  page.hash = new Date().getTime()
  page.metadata = buildMetadata(page.metadata)

  if (page.contents && !page.components) {
    page.components = []

    page.contents.forEach((content, index) => {
      var componentToRender = {
        contentType: getComponentType(content.contentType),
        componentName: getComponentName(content.contentType),
        content: JSON.parse(content.content),
        sortOrder: content.sortOrder,
        metadata: buildMetadata(content.metadata),
        parent: null,
        hash: new Date().getTime() + index,
        preload: () => Promise.resolve()
      }

      async function getHomeImage(block) {
        const result = await dataAccess.getFile(componentToRender.content[block].imageId)
        componentToRender.content[block].image = result
      }

      switch (content.contentType) {
        case ContentTypes.Tabs: {
          if (componentToRender.metadata.mode === TabsModes.Subpage) {
            componentToRender.preload = async function () {
              const ids = componentToRender.content.map((item) => item.id)
              const tabs = await dataAccess.getTabs(ids)
              componentToRender.content = sortBy(componentToRender.content.map((tab) => {
                const tabItem = find(tabs, (t) => t.id === tab.id)
                return merge(tab, tabItem)
              }), ['sortOrder'])
              componentToRender.metadata.parentUrlKey = page.urlKey
            }
          }
          break
        }
        case ContentTypes.Home: {
          componentToRender.preload = async function () {
            const data = [getHomeImage('mainBlock'), getHomeImage('secondBlock')]
            await Promise.all(data)
          }
          break
        }
      }
      componentToRender.parent = page

      if (componentToRender != null) {
        page.components.push(componentToRender)
      }
    })

    const loadPromise = map(page.components, (f) => f.preload())

    await Promise.all(loadPromise)
    page.components.sort(e => e.sortOrder)
  }
  await loadSubPage(page)
}

function getComponentName(contentType) {
  var componentName = ''
  switch (contentType) {
    case ContentTypes.ShareButtons:
      componentName = 'share-buttons'
      break
    case 'PersonalVideo':
      componentName = 'Personal-video'
      break
    case ContentTypes.Map:
      componentName = 'maps'
      break
    default:
      componentName = contentType.toLowerCase()
      break
  }
  return componentName
}

function getComponentType(contentType) {
  var type = null
  switch (contentType) {
    case 'PersonalVideo':
      type = 'Personal-video'
      break
    default:
      type = contentType
      break
  }
  return type
}

async function loadPage(to, next) {
  var options = {}
  options.accept = next
  options.reject = () => next(false)
  options.notFound = () => next({ path: '/404' })
  await this.load(to, options.accept, options.reject, options.notFound)
}

async function load(to, accept, reject, notFound) {
  var urlKey = to.params.urlKey
  try {
    var page = tryGetCurrentPage(urlKey, [to.params.subUrlKey])
    if (page == null) {
      store.dispatch('clearPage')
    }
    await store.dispatch('loadPage', { page: page, urlKey: urlKey, args: [to.params.subUrlKey] }).then(accept())
  } catch (err) {
    if (err.code === 'RESOURCENOTFOUND') {
      notFound()
    } else {
      reject()
    }
  }
}

function buildMetadata(value) {
  let metadata
  if (typeof value === 'string' || value instanceof String) {
    try {
      metadata = JSON.parse(value)
    } catch (err) {
      metadata = {}
    }
  } else {
    metadata = value || {}
  }
  return metadata
}

function tryGetCurrentPage(urlKey, args) {
  var page = store.getters.page
  page = (page && page.urlKey === urlKey) ? cloneDeep(page) : null
  if (page && !isEqual(page.args, args)) {
    page.args = args
  }
  return page
}
